module.exports = __webpack_public_path__ + "assets/img/main-logo-qinhuangdao.c14e945b.png";